import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

const INCLUDED = [
  "A 5-stop journey of 100 questions made for your child's class",
  "Pause anytime and continue from the same question",
  "A personal guidance report, on screen and as a PDF",
  "Your report delivered to your email",
  "Courses, colleges and universities in India (Classes 9-12)",
  "A one-on-one counsellor session on request",
];

export default function Pricing() {
  const [price, setPrice] = useState(499);
  useEffect(() => { api.get("/public/config").then((r) => setPrice(r.data.price_inr)).catch(() => {}); }, []);

  return (
    <section id="pricing" className="ds-section bg-ds-cream" data-testid="landing-pricing">
      <div className="container-x grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 space-y-4">
          <p className="eyebrow text-ds-plum">Pricing</p>
          <h2 className="ds-h2">One simple step towards a clearer future.</h2>
          <p className="text-[17px] text-ds-inksoft leading-relaxed">No subscriptions and no surprises. Pay once for each student, and begin whenever your child is ready.</p>
          <p className="flex items-center gap-2 text-[15px] text-ds-ink"><ShieldCheck className="h-4 w-4 text-[#5E8C4F]" /> Secure payments by Razorpay: cards, UPI and netbanking</p>
        </div>
        <div className="lg:col-span-7">
          <div className="relative rounded-[24px] bg-white border border-ds-plum/15 p-8 sm:p-10 shadow-[0_24px_60px_-36px_rgba(79,3,65,0.4)]" data-testid="pricing-card">
            <div className="relative grid sm:grid-cols-2 gap-8">
              <div>
                <p className="font-display text-xl font-semibold text-ds-plumdeep">Career discovery</p>
                <p className="mt-3 font-display text-6xl font-semibold text-ds-plum" data-testid="pricing-amount">&#8377;{price}</p>
                <p className="mt-1 text-[15px] text-ds-inksoft">per student, all inclusive</p>
                <Link to="/signup" className="ds-btn mt-8 bg-ds-amber text-ds-plumdeep hover:bg-[#c97520]" data-testid="pricing-cta">Start the journey</Link>
              </div>
              <ul className="space-y-3.5 sm:border-l sm:border-dashed sm:border-ds-plum/20 sm:pl-8">
                {INCLUDED.map((i) => (
                  <li key={i} className="flex gap-3 text-[15px] text-ds-ink leading-snug"><span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full border-2 border-ds-plum" />{i}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
